import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Loader2 } from "lucide-react";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Upload from "@/pages/Upload";
import Review from "@/pages/Review";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Categories from "@/pages/Categories";
import CategoryDetail from "@/pages/CategoryDetail";
import Entities from "@/pages/Entities";
import EntityDetail from "@/pages/EntityDetail";
import Search from "@/pages/Search";
import FileDetail from "@/pages/FileDetail";
import Users from "@/pages/Users";
import Audit from "@/pages/Audit";

function FullLoader() {
  return <div className="min-h-screen flex items-center justify-center bg-[#0B0F19]"><Loader2 className="w-8 h-8 animate-spin text-blue-500" /></div>;
}

function Protected({ children, staffOnly, adminOnly }) {
  const { user, isStaff } = useAuth();
  const loc = useLocation();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (staffOnly && !isStaff) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/upload" element={<Protected staffOnly><Upload /></Protected>} />
      <Route path="/review" element={<Protected staffOnly><Review /></Protected>} />
      <Route path="/projects" element={<Protected><Projects /></Protected>} />
      <Route path="/project/:id" element={<Protected><ProjectDetail /></Protected>} />
      <Route path="/categories" element={<Protected><Categories /></Protected>} />
      <Route path="/category/:id" element={<Protected><CategoryDetail /></Protected>} />
      <Route path="/people" element={<Protected><Entities type="person" /></Protected>} />
      <Route path="/organizations" element={<Protected><Entities type="organization" /></Protected>} />
      <Route path="/entity/:id" element={<Protected><EntityDetail /></Protected>} />
      <Route path="/search" element={<Protected><Search /></Protected>} />
      <Route path="/file/:id" element={<Protected><FileDetail /></Protected>} />
      <Route path="/users" element={<Protected adminOnly><Users /></Protected>} />
      <Route path="/audit" element={<Protected adminOnly><Audit /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
